import { Client as CoreInterface } from "@ideal-postcodes/core-interface";
import { Agent } from "./agent";
export class Client extends CoreInterface {
    /**
     * Client constructor extends CoreInterface
     */
    constructor(config) {
        const agent = new Agent();
        super({ agent, ...config });
    }
}
